import { IconButton } from '@mui/material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { AnimalScaleIcon } from 'features/AnimalScale/AnimalScaleIcon'
import { newProjectActions } from 'features/BillOfMaterials/store/projectReducer'
import { isEqual } from 'lodash'
import { AnimalScale } from 'services/APIs/InternalAPI/internal-api.contracts'
import { useAppDispatch, useAppSelector } from 'store/configureStore'

export const AnimalScaleFilter = () => {
  const dispatch = useAppDispatch()

  const animalScalesFilter = useAppSelector((state) => {
    return state.project.filters?.byAnimalScale?.filter
  }, isEqual)

  const handleChange = (scale: AnimalScale) => {
    if (
      animalScalesFilter.enabledFilters &&
      animalScalesFilter.enabledFilters.includes(scale)
    ) {
      // Remove from enabled filters
      const newEnabledFilters = animalScalesFilter.enabledFilters.filter(
        (s) => s !== scale,
      )
      dispatch(
        newProjectActions.setFilter({
          filter: {
            ...animalScalesFilter,
            enabledFilters: newEnabledFilters,
            type: 'AnimalScaleFilter',
          },
        }),
      )
    } else {
      // Add to enabled filters
      const newEnabledFilters = [
        ...(animalScalesFilter.enabledFilters || []),
        scale,
      ]
      dispatch(
        newProjectActions.setFilter({
          filter: {
            ...animalScalesFilter,
            enabledFilters: newEnabledFilters,
            type: 'AnimalScaleFilter',
          },
        }),
      )
    }
  }

  if (
    !animalScalesFilter.availableFilters ||
    animalScalesFilter.availableFilters.length === 0
  ) {
    return null
  }

  return (
    <div style={{ padding: '8px', paddingBottom: 0 }}>
      <LocalizedTypography
        translationKey="project:scale"
        variant="subtitle2"
        gutterBottom
        color="textSecondary"
      >
        scale
      </LocalizedTypography>
      <div
        style={{
          display: 'flex',
          gap: '0.5rem',
          flexWrap: 'wrap',
          paddingLeft: '8px',
        }}
      >
        {animalScalesFilter.availableFilters.map((scale) => (
          <IconButton
            key={scale}
            size="small"
            color={
              animalScalesFilter.enabledFilters &&
              animalScalesFilter.enabledFilters.includes(scale)
                ? 'primary'
                : 'default'
            }
            sx={{
              width: (t) => t.spacing(4),
              backgroundColor:
                animalScalesFilter.enabledFilters &&
                animalScalesFilter.enabledFilters.includes(scale)
                  ? (t) => t.palette.info.light
                  : 'transparent',
              '& path': {
                fill:
                  animalScalesFilter.enabledFilters &&
                  animalScalesFilter.enabledFilters.includes(scale)
                    ? (t) => t.palette.info.contrastText
                    : (t) => t.palette.text.primary,
              },
              '&:hover': {
                backgroundColor:
                  animalScalesFilter.enabledFilters &&
                  animalScalesFilter.enabledFilters.includes(scale)
                    ? (t) => t.palette.primary.light
                    : (t) => t.palette.action.hover,
              },
            }}
            onClick={() => handleChange(scale)}
          >
            <AnimalScaleIcon
              scale={scale}
              tooltipProps={{
                placement: 'top',
              }}
            />
          </IconButton>
        ))}
      </div>
    </div>
  )
}
